module.exports = __webpack_public_path__ + "img/measurement_info_left_shoulders.b5d7dc0d.jpg";